import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Controller, useFormState } from 'react-hook-form';
import sharedStyles from '../../../styles/globals/index.module.scss';
import { Width } from '../../Width/index.js';
import { Label } from '../../Label/index.js';
import { constructClassName } from '../../../utils/constructClassName/index.js';
import { getNestedValue } from '../../../utils/getNestedValue/index.js';
import { Description } from '../../Description/index.js';
import { Error } from '../../Error/index.js';
import styles from './styles.module.scss';
export const TextAreaInput = ({ control, defaultValue, description, label, name, required, rules, width, placeholder, onChange: onChangeFromProp, showInlineLabel, hideLabel, classNames, ...rest }) => {
    const { errors } = useFormState({
        control,
        name: ['errors'],
    });
    const errorMessage = getNestedValue(errors, name)?.message;
    return ((_jsx(Width, { width: width, children: _jsxs("div", { className: constructClassName([
                sharedStyles.container,
                classNames?.container,
            ]), children: [_jsx(Controller, { name: name, control: control, defaultValue: defaultValue || null, rules: {
                        required: required && {
                            message: `${label} is required`,
                            value: Boolean(required),
                        },
                        ...rules,
                    }, render: ({ field: { onChange, onBlur, value, ref, disabled }, fieldState: { isDirty } }) => (_jsxs(React.Fragment, { children: [_jsx(Label, { htmlFor: name, label: label, required: required, placeholder: placeholder, hideLabel: hideLabel, showInlineLabel: showInlineLabel || (showInlineLabel !== false && !label && isDirty), className: constructClassName([
                                    classNames?.label,
                                ]) }), _jsx("textarea", { ref: ref, id: name, name: name, className: constructClassName([
                                    sharedStyles.input,
                                    styles.textarea,
                                    classNames?.input,
                                ]), disabled: disabled, onBlur: onBlur, value: value || '', onChange: (e) => {
                                    onChange(e.target.value);
                                    onChangeFromProp?.(e.target.value);
                                }, placeholder: isDirty ? undefined : placeholder, ...rest })] })) }), description && (_jsx(Description, { description: description, className: constructClassName([
                        classNames?.description,
                    ]) })), errorMessage && (_jsx(Error, { message: errorMessage, className: constructClassName([
                        classNames?.error,
                    ]) }))] }) })));
};
